import { useParams } from 'react-router-dom';

import { useCreditCardDetails } from '@/components/modules/_shared/hooks/useCreditCard';
import { CreditCardConfiguration } from '@/components/modules/CreditCard/Detail/CardConfiguration/components/CreditCardConfiguration';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { PendingDataType } from '@/config/types';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const CreditCardDetails = () => {
  const { creditCardId } = useParams();

  if (!creditCardId) return null;

  const { creditCardDetails } = useCreditCardDetails({ creditCardId });

  if (!creditCardDetails) {
    return <PendingDataWarning type={PendingDataType.NO_DATA_TO_DISPLAY} />;
  }

  return <CreditCardConfiguration creditCardConfiguration={creditCardDetails.configuration} />;
};

export const CreditCardDetailsModule = withPermissionsModule(CreditCardDetails);
